module.exports = __webpack_public_path__ + "uarm-images/ui-icons_777777_256x240.png";